export default "__VITE_ASSET__BrFbO_NQ__"